export default "__VITE_ASSET__Bsk$TJwi__"